import React, { useRef } from 'react';
import { View, StyleSheet, Text, ViewStyle } from 'react-native';
import { padding, scaleW, styles } from '@/common/style';
import { $k18n } from '@/common/i18n';
import CommentCard from '@/component/CommentCard';
import CommentCardMini from '@/component/CommentCard/MiniCard';
import { vIf } from '@/common/utils/vIf';
import ImagePreview from '@kibt/meta-ui-krn/lib/components/ImagePreview';
import { useSetState } from '@/hooks/useSetState';
import CloseWithBackground from '@/assets/icon_detail/closeWithBackground.png';
import { logClickCommentLineNew, logShowCommentLine } from '../../../logger2.0';
import { HorizontalGestureConflictView } from '@/component/HorizontalGestureConflictView';
import SelectTag from '@/component/SelectTags/SelectTags';
import Image from '@kds/image';
import { useDetailPageStore } from '@/page/detail/store';
import { KTouchableOpacity } from '@/component/RtlLayout/Touchable';
import { ViewVisible } from '@/component/ViewVisible/ViewVisible';
import { PurePreviewVideo, PureVideoPreviewHandle } from '../Video';
import { useSafeAreaInsetTop } from '@/hooks/useSafeAreaInsetTop';
import MyImage from '../MyImage';
import { isAndroid } from '@kibt/krn-utils';
import { useCallApp } from '@/common/callApp';

const style = StyleSheet.create({
    container: {
        ...padding(scaleW(16), scaleW(19)),
        paddingBottom: scaleW(8),
        backgroundColor: '#fff',
        marginBottom: scaleW(8),
        position: 'relative',
    },
    header: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    title: {
        color: '#000',
        fontSize: 15,
        lineHeight: 18,
        fontWeight: '500',
    },
    text: {
        marginTop: scaleW(10),
        color: '#000',
        fontSize: 14,
        lineHeight: scaleW(21),
    },
});

const CommentLine = (props: { isEvaluationABTest: boolean; hasBottomMargin?: boolean }) => {
    const { isEvaluationABTest, hasBottomMargin = true } = props;
    const pageRawData = useDetailPageStore(s => s.pageRawData);
    const comments = pageRawData?.comments || [];
    const commentCount = pageRawData?.totalCommentCnt?.displayAmount || 0;
    const tagCnt = pageRawData?.tagCnt || [];

    const { callApp } = useCallApp();

    const onClickHeader = () => {
        if (!isEvaluationABTest) {
            return;
        }
        logClickCommentLineNew({});
        callApp({ pageId: 'ecomm_commodity_detail' });
    };
    const onClickHeaderCopy = () => {
        logClickCommentLineNew({});
        callApp({ pageId: 'ecomm_commodity_detail' });
    };

    const onCommentLineShow = () => {
        let logCommentsInfo = null;
        if (comments?.length) {
            logCommentsInfo = pageRawData.abTest?.ratingFloorHeight ? [comments?.[0]] : comments;
        }
        logShowCommentLine(logCommentsInfo);
    };

    if (!pageRawData?.totalCommentCnt?.amount) return null;

    return (
        <ViewVisible rootMargin={{ top: 0, left: 0, right: 0, bottom: 100 }} onVisible={onCommentLineShow}>
            <View style={[style.container, !hasBottomMargin ? { marginBottom: 0 } : null]}>
                <KTouchableOpacity activeOpacity={0.6} onPress={onClickHeader}>
                    <KTouchableOpacity activeOpacity={0.6} onPress={onClickHeaderCopy}>
                        <View style={style.header}>
                            <Text style={style.title}>
                                {$k18n({ text: '商品评价', id: 'k_442589' })}
                                {vIf(Boolean(commentCount), ` (${commentCount})`)}
                            </Text>
                            <MyImage
                                imageSrc={{
                                    uri: 'https://cdn-static.ap4r.com/kos/s101/nlav11312/shop-krn/kibt_post_import_album_icon_arrow_106.png',
                                }}
                            />
                        </View>
                    </KTouchableOpacity>
                    <View style={{"marginTop":"2.8985507246376816rem"}}>
                        {tagCnt?.length ? (
                            <View>
                                <SelectTag tagList={tagCnt} disabled />
                                <View
                                    style={{"width":"100%","height":"0.24154589371980678rem","backgroundColor":"#F2F2F2","marginBottom":"2.8985507246376816rem","marginTop":"0.9661835748792271rem"}}
                                />
                            </View>
                        ) : null}
                        {comments.length ? (
                            <>
                                {pageRawData.abTest.ratingFloorHeight ? (
                                    <View>
                                        <CommentCardMini
                                            {...comments[0]}
                                            onClickImage={({ videoAndImgs, index: _index }) => {
                                                callApp({ pageId: 'ecomm_commodity_detail' });
                                            }}
                                        />
                                    </View>
                                ) : (
                                    comments.map((comment, index) => (
                                        <View style={{"marginTop":"3.381642512077295rem"}}>
                                            <CommentCard
                                                {...comment}
                                                max={3}
                                                showTime={false}
                                                onClickImage={({ videoAndImgs, index: _index }) => {
                                                    callApp({ pageId: 'ecomm_commodity_detail' });
                                                }}
                                            />
                                        </View>
                                    ))
                                )}
                            </>
                        ) : null}
                    </View>
                </KTouchableOpacity>
                {Number(commentCount) ? null : <Text style={style.text}>{$k18n({ text: '暂无历史评价', id: 'k_442588' })}</Text>}
                {isEvaluationABTest ? (
                    <View
                        style={{"height":"0.24154589371980678rem","width":"90.33816425120774rem","backgroundColor":"rgba(242, 242, 242, 1)","position":"absolute","bottom":"0rem","left":"4.830917874396135rem"}}
                    />
                ) : null}
            </View>
        </ViewVisible>
    );
};

export default CommentLine;
